import { mergeAttributes, Node } from "@tiptap/core";

const block = (name: string, className: string) => Node.create({
  name,
  group: "block",
  content: "block+",
  defining: true,
  parseHTML: () => [{ tag: `section[data-block="${name}"]` }],
  renderHTML: ({ HTMLAttributes }) => ["section", mergeAttributes(HTMLAttributes, { "data-block": name, class: className }), 0],
});

export const MorrocarsCallout = block("morrocarsCallout", "morrocars-callout");
export const MorrocarsCta = block("morrocarsCta", "morrocars-cta");
